export default "__VITE_ASSET__ac67668e__"